let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("d0QEA")).then(() => parcelRequire('2uo4o'));